import { useContext } from 'react'
import { AppContext } from '@state/context'
import { useCurrentUser } from '@hooks/useCurrentUser'
import { USER_ROLES } from '@helpers/constants'

const useExamsAllowed = () => {
  const [state] = useContext(AppContext)
  const {
    app: { userId, userRole, userSchools },
  } = state

  const { currentUser } = useCurrentUser()
  const { hasPaidLicense } = currentUser || {}

  // Exams is allowed on certain schools
  const allowedSchoolIds = [
    // 6600, // "Dokletskolan"
    // 6625, // "Rakets testskola"
    // 6626, // "Rakets testskola (utan PUB-avtal)"
    6613, // "Fågleholmsskolan"
  ]

  if (process?.env?.NODE_ENV === 'development') {
    return true
  }

  if (userRole === USER_ROLES.ADMIN) {
    return true
  }

  if (
    Array.isArray(userSchools) &&
    userSchools.some((school) => allowedSchoolIds.includes(school.id))
  ) {
    return true
  }

  if (hasPaidLicense) {
    return true
  }

  return false
}

export { useExamsAllowed }
